import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', formatDate)
Vue.filter('point', point)
Vue.filter('monthLong', monthLong)
Vue.filter('pointDecimal', pointDecimal)
Vue.filter('moneyDecimal', moneyDecimal)

export function formatDate(value, format) {
  if (value) {
    return moment(String(value)).format(format || 'DD-MM-YYYY hh:mm')
  }
}

export function point(value) {
  return parseInt(value)
}

export function pointDecimal(value) {
  return parseFloat(value).toFixed(1)
}

export function moneyDecimal(value) {
  return parseFloat(value).toFixed(2)
}

export function monthLong(value) {
  var objDate = new Date(value),
      locale = "pl-PL",
      month = objDate.toLocaleString(locale, { month: "long" })

  return month
}



// WEBPACK FOOTER //
// ./src/app/filters.js